module.exports = __webpack_public_path__ + "img/shop-details-bak.197790aa.png";